export default "__VITE_ASSET__CeHpAygo__"